import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  CircularProgress,
  Tooltip,
} from '@mui/material';
import { Add as AddIcon, Settings as SettingsIcon, Assessment as MarksIcon, Visibility as ViewIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layout/MainLayout';
import axios from 'axios';

const ExaminationList: React.FC = () => {
  const [examinations, setExaminations] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchExaminations();
  }, []);

  const fetchExaminations = async () => {
    try {
      const response = await axios.get('/exams');
      setExaminations(response.data);
    } catch (error) {
      console.error('Failed to fetch examinations:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <MainLayout>
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        </Container>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4">Examinations</Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate('/examinations/create')}
          >
            New Examination
          </Button>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Start Date</TableCell>
                <TableCell>End Date</TableCell>
                <TableCell>Classes</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {examinations.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography variant="body2" color="textSecondary" sx={{ py: 3 }}>
                      No examinations found. Create your first examination to get started.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                examinations.map((exam) => (
                  <TableRow key={exam.id}>
                    <TableCell>{exam.name}</TableCell>
                    <TableCell>
                      <Chip label={exam.examType?.name} size="small" variant="outlined" />
                    </TableCell>
                    <TableCell>{new Date(exam.startDate).toLocaleDateString()}</TableCell>
                    <TableCell>{new Date(exam.endDate).toLocaleDateString()}</TableCell>
                    <TableCell>
                      {exam.classes?.length || 0}
                    </TableCell>
                    <TableCell>
                      <Tooltip title="Manage (Classes/Subjects)">
                        <IconButton onClick={() => navigate(`/examinations/${exam.id}/manage`)}>
                          <SettingsIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Enter Marks">
                        <IconButton onClick={() => navigate(`/examinations/${exam.id}/marks`)}>
                          <MarksIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="View Results">
                        <IconButton onClick={() => navigate(`/examinations/${exam.id}/results`)}>
                          <ViewIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </MainLayout>
  );
};

export default ExaminationList;
